export default "__VITE_ASSET__BlxS4XO2__"